import React, { useContext } from 'react';
import { Box } from '@mui/material';

import FormPreventivatoreCompact from '../preventivatore/FormPreventivatoreCompact';
import ResultsQuotationRenderList from './ResultsQuotationRenderList';
import ResultsQuotationHeader from './ResultsQuotationHeader';
import ResultsIntroList from './ResultsIntroList';
import useResultsQuotation from './useResultsQuotation';
import { CmsPageContext } from '../../pages/[...path]';

const RESULTS_TO_SHOW_WHEN_COLLAPSED = 6;

const HEADER_DESCRIPTION = '';
  // 'Lo sapevi che i nostri consulenti hanno successo in più dell’80% di pratiche contro una media nazionale di circa il 50%? Con TassoMutuo hai più possibilità di ottenere il tuo mutuo!';

const ResultsQuotation = ({ defaultQuotationResults = [], defaultEstimatorData = {}, banks = [] }) => {
  const { pageTitle } = useContext(CmsPageContext);

  const { sendDataHandler, defaultFinalita, isLoading, quotationResults, onProductClick } = useResultsQuotation({
    banks,
    defaultQuotationResults,
    defaultEstimatorData,
  });

  return (
    <Box className="moduleResultsContainer">
      <ResultsQuotationHeader title={pageTitle} description={HEADER_DESCRIPTION} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          '@media (min-width: 992px)': {
            flexDirection: 'row',
          },
        }}>
        <Box className="container_results_page">
          <div>
            <h5 className="onlydesktop" style={{margin:'0 0 10px 0'}}>La tua ricerca</h5>
            <Box className="formContainer">
              <FormPreventivatoreCompact
                finalitaOptions={defaultFinalita}
                sendData={sendDataHandler}
                estimatorData={defaultEstimatorData}
                resetList={() => {}}
                loading={isLoading}
              />
            </Box>
          </div>
        </Box>
        <div>
          <ResultsIntroList estimatorData={defaultEstimatorData} quotationResults={quotationResults} />
          <ResultsQuotationRenderList
            resultsToShow={RESULTS_TO_SHOW_WHEN_COLLAPSED}
            quotationResults={quotationResults}
            onProductClick={onProductClick}
          />
        </div>
      </Box>
    </Box>
  );
};

export default ResultsQuotation;
